import { FunctionComponent, useState, useEffect } from 'react'
import { MessageBar, MessageBarBody, MessageBarTitle } from '@fluentui/react-message-bar'
import { useGenericListSettings } from '@knowmax/genericlist-core'

/** Displays error message.
 * @param error Error object or string.
 * @param title Optional title.
 */
export const ErrorMessage: FunctionComponent<{ error?: Error | string, title?: string }> = ({ error, title }) => {
  const genericlistsettings = useGenericListSettings();
  const [message, setMessage] = useState<string | undefined>();

  useEffect(() => {
    if (typeof error === 'string') {
      setMessage(error);
    } else if (error) {
      genericlistsettings.onErrorMessage(error).then((m) => setMessage(m));
    }
  }, [error, genericlistsettings])

  return (
    <MessageBar intent='error' role="alert">

      <MessageBarBody>
        {title &&
          <MessageBarTitle>{title}</MessageBarTitle>
        }
        {message}
      </MessageBarBody>

    </MessageBar>
  )
}